<bb-frame-select [mediaclip]="mediaclip" [image]="image" [select]="mediaclip ? 'single' : null" [cropSelect]="true" (cropsetchange)="onCropsetChange($event)"></bb-frame-select>

<div class="action-buttons">
	<bb-button class="cancel" (click)="onCancelClick()">
		{{ 'CANCEL' | translate }}
	</bb-button>
	<bb-button [active]="true" (click)="onSaveClick()" data-cy="save-screenshot-button">
		{{ (isNew ? 'CREATE_THUMBNAIL' : 'APPLY_CHANGES') | translate }}
	</bb-button>
</div>
